<!--footer section -->
<footer [ngClass]="class">
    <div class="dark-layout" *ngIf="mainFooter">
        <div class="container">
            <section class="section-b-space border-b">
                <div class="row footer-theme2">
                    <div class="col-lg-3">
                        <div class="footer-title footer-mobile-title">
                            <h4>about</h4>
                        </div>
                        <div class="footer-contant">
                            <div class="footer-logo" id="footerlogo">
                                <img class="footer-logo-size" [src]="themeLogo"  alt="logo">
                            </div>
                            <div class="social-white">
                                <ul class="move-social-for-desktop">
                                    <li>
                                        <a target="_blank" href="https://www.facebook.com/profile.php?id=100085959177605"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://www.instagram.com/outgravitywear/"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 subscribe-wrapper">
                        <div class="subscribe-block">
                            <h2>newsletter</h2>
                            <form *ngIf="!showThanksForNewsletter">
                                <div class="form-group">
                                    <input [(ngModel)]="email" type="text" name="emailAddress" class="form-control" id="exampleFormControlInput3" placeholder="Inserisci la tua mail">
                                    <button (click)="onAddNewsletterContact()" type="submit" class="btn btn-solid ">ISCRIVITI</button>
                                </div>
                            </form>
                            <label class="mt-3">Iscriviti alla nostra Newsletter e riceverai subito un codice sconto del 10%.</label>
                            <div *ngIf="showThanksForNewsletter">
                                <label>Grazie per esserti iscritto alla nostra newsletter</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="footer-title">
                            <h4>store information</h4>
                        </div>
                        <div class="footer-contant">
                            <ul class="contact-details">
                                <li><a [routerLink]="['/pages/resi-spedizione']" fragment="spedizioni">Spedizioni</a></li>
                                <li><a [routerLink]="['/pages/resi-spedizione']" fragment="resi">Politica Resi</a></li>
								<li><a [routerLink]="['/pages/resi-spedizione']" fragment="reso">Effettua un reso</a></li>
                                <li>
                                    <a target="_blank" href="https://www.iubenda.com/termini-e-condizioni/91785635" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe " title="Termini e Condizioni ">Termini e Condizioni</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
                                </li>
                                <li>
                                    <a target="_blank" href="https://www.iubenda.com/privacy-policy/91785635" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
                                </li>
                                <li><a target="_blank" href="mailto:info@out-wear.com">Contattaci</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="sub-footer darker-subfooter">
        <div class="container">
            <div class="row">
                <div class="col text-center intestazione">
                    2023, OUT di Soresina Riccardo - P. Iva: 03092570302 - 33100 Udine (UD), Italia.
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="footer-end">
                    <p style="font-size: 70%;">Website developed by Gabriele Francescutto</p>
                  </div>
                </div>
                <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="payment-card-bottom">
                    <ul>
                      <li>
                        <a href="javascript:void(0)">
                            <img src="web/assets/images/icon/visa.png" alt="">
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">
                            <img src="web/assets/images/icon/mastercard.png" alt="">
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">
                            <img src="web/assets/images/icon/paypal.png" alt="">
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<!--footer section end -->